// src/App.js

import React from 'react';
import AppRoutes from './Routes';
import './App.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
